import { useEffect, useState } from "react";
import { Steps, Button, Form } from "antd";
import * as Yup from "yup";
import { useFormik } from "formik";
import { addBusiness, getAllSector, addSector } from "../../../developer/services/developerApi";
import { useQuery, useQueryClient } from "react-query";
import toast from "react-hot-toast";
import FormField from '../../../../common/Form/FormField';

import { Col, Row } from "reactstrap";

import countryList from "react-select-country-list";
import SelectField from "../../../../common/Form/SelectField";
import CreatableSelectField from "../../../../common/Form/CreatableSelect";
import { deleteManyFilesBusiness, deleteMedia, uploadImage, uploadManyFilesBusiness } from "../../../media/services/mediaApi";
import Lottie from "lottie-react";
import loadingAnim from "../../../../assets/animations/loading.json";

import { FormatErrorVersement } from "../../../../common/errorformat/errorFormat";
import PaymentMethodSelector from "../../../developer/component/PaymentMethodSelector";
import RecapForm from "../../../developer/component/recapForm";
import UploadDocument from "../../../developer/component/uploadDoc";

const { Step } = Steps;

const AddFirstBusiness = ({ currentuser, paymentList, isLoadingPaym, isErrorPaym, errorPaym, onBusinessCreated }) => {
    const [currentStep, setCurrentStep] = useState(0);
    const [form] = Form.useForm();
    const queryClient = useQueryClient();
    const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);
    const [logoFile, setLogoFile] = useState(null);
    const [imageUrl, setImageUrl] = useState(null);
    const merchandId = currentuser?.user?.id || currentuser?.userId;
    const [documents, setDocuments] = useState({
        businessRegistryFileName: null,
        nineaFileName: null,
        statutFileName: null,
    });
    const [uploadedDocs, setUploadedDocs] = useState(null);
    const [isUploadingDocs, setIsUploadingDocs] = useState(false);
    const [error, setError] = useState(null);

    const countries = countryList().getData();
    const { data: sectors, isLoading: isLoadSect, isError: isErrorSect, error: errorSect } = useQuery("sectors", getAllSector);

    const handleUploadLogo = (file) => {
        const reader = new FileReader();
        reader.onload = (e) => setImageUrl(e.target.result);
        reader.readAsDataURL(file);
        setLogoFile(file);
        return false;
    };
  
    const handleDocChange = (name, file) => {
        setDocuments((prev) => ({
        ...prev,
        [name]: file,
        }));

        setUploadedDocs(null);
    };

    useEffect(() => {
        const { businessRegistryFileName, nineaFileName, statutFileName } = documents;

        if (!businessRegistryFileName || !nineaFileName || !statutFileName) return;

        const uploadDocs = async () => {
        setIsUploadingDocs(true);
        try {
            const res = await uploadManyFilesBusiness(documents);
            setUploadedDocs(res);
        } catch (err) {
            console.error("Erreur upload documents", err);
        } finally {
            setIsUploadingDocs(false);
        }
        };

        uploadDocs();
    }, [documents]);

    const validationSchema = Yup.object().shape({
        businessName: Yup.string().required("Oups!!! Veuillez renseigner le nom"),
        documents: Yup.array().min(1, "Les documents sont obligatoires"),
        countryPaymentMethods: Yup.array().min(1, "Sélectionnez au moins une méthode de paiement"),
    });

    const validateDocuments = () => {
        const { businessRegistryFileName, nineaFileName, statutFileName } = documents;
        if (!businessRegistryFileName || !nineaFileName || !statutFileName) {
            toast.error("Tous les documents du business sont obligatoires !");
            return false;
        }
        return true;
    };

    const initialValues = {
        logo: "",
        businessRegistryFileName: "",
        nineaFileName: "",
        statutFileName: "",
        businessName: "",
        description: "",
        type: "",
        country: "",
        sectorId: "",
        type: "COMPANY",
        countryPaymentMethods: [],
    };

    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit: async (values) => {
        if (isUploadingDocs) {
            return toast.error("Upload des documents en cours...");
        }
        
        setIsLoadingSubmit(true);
        let uploadedLogo = null;

        try {
            if (logoFile) {
            const res = await uploadImage("logo", logoFile);
            values.logo = res?.fileName;
            uploadedLogo = res?.fileName;
            }

            const mappedPaymentMethods = values.countryPaymentMethods.map((countryBlock) => ({
            country: countryBlock.country,
            paymentMethods: countryBlock.paymentMethods.map((method) => ({
                id: method.id,
                name: method.name,
                type: method.type,
                prefixCode: method.prefixCode,
                currency: method.currency,
                urlLogo: method.urlLogo,
            })),
            }));

            // const payload = { ...values, countryPaymentMethods: mappedPaymentMethods,...uploadedDocs, merchandId };
            const payload = {
            ...values,
            countryPaymentMethods: mappedPaymentMethods,
            merchandId,
            businessRegistryFileName: uploadedDocs?.businessRegistryFileName,
            nineaFileName: uploadedDocs?.nineaFileName,
            statutFileName: uploadedDocs?.statutFileName,
            ...(uploadedLogo && { logo: uploadedLogo }),
            };
            
            const createdBusiness = await addBusiness(payload);
            
            if (onBusinessCreated) {
                onBusinessCreated(createdBusiness);
            }

            // await queryClient.invalidateQueries("developers");
            // formik.resetForm();
        } catch (error) {
            setError(error?.response?.data?.message)
            // const formatted = FormatErrorVersement(error?.response?.data);
            // setError(formatted.message);
            toast.error("Erreur, merci de contacter le support.");
            if (uploadedLogo) await deleteMedia(uploadedLogo);
            if (uploadedDocs) await deleteManyFilesBusiness(documents);
        } finally {
            setIsLoadingSubmit(false);
        }
        },
    });

    const next = () => setCurrentStep(currentStep + 1);
    const prev = () => setCurrentStep(currentStep - 1);

    const renderBasicInfoForm = () => {
        const sectorOptions = (sectors || []).map((s) => ({ value: s.id, label: s.name }));

        const handleCreateSector = async (inputValue) => {
        const cleanedInput = inputValue.trim().toLowerCase();
        const existing = sectorOptions.find(opt => opt.label.toLowerCase() === cleanedInput);
        if (existing) return formik.setFieldValue("sector", existing.value);
        try {
            const newSector = await addSector(inputValue);
            if (newSector?.id) {
            formik.setFieldValue("sector", newSector.id);
            queryClient.invalidateQueries("sectors");
            }
        } catch (err) {
            console.error("Erreur création secteur:", err);
        }
        };
        
        const typeList = [
        { id: "PARTICULAR", label: "Particulier" },
        { id: "COMPANY", label: "Entreprise" }
        ];


        return (
        <Form form={form} layout="vertical">
            <h5 className="title-addEdit-Step">Informations basiques</h5>
            {/* <Form.Item label="Logo">
            <div className="dev-logo-upload-container">
                <div className="dev-logo-placeholder">
                {imageUrl ? (
                    <img className="dev-logo-placeholder-img" src={imageUrl} alt="Logo" />
                ) : (
                    <PictureOutlined className="dev-logo-icon" />
                )}
                </div>
                <Upload showUploadList={false} beforeUpload={handleUploadLogo}>
                <Button className="upload-btn">
                    <UploadOutlined /> Uploader
                </Button>
                </Upload>
            </div>
            </Form.Item> */}

            <Row>
                <FormField label="Nom" name="businessName" formik={formik} colSize={6} placeholder="Le nom de votre business" style={{ height: '44px' }}/>
                <SelectField label="Type" name="type" nameSelect="le type du business" formik={formik} options={typeList} error={formik.errors.country} colSize={6} />
                <SelectField label="Pays" name="country" nameSelect="son pays d'origine" formik={formik} options={countries} error={formik.errors.country} colSize={6}  />
                <CreatableSelectField label="Secteur d’activité" name="sectorId" formik={formik} options={sectorOptions} error={formik.errors.sectorId} colSize={6} isError={isErrorSect} errorApi={errorSect} isLoading={isLoadSect} onCreateOption={handleCreateSector} />
                <FormField label="Description" name="description" formik={formik} colSize={12} placeholder="Entrez la description de votre business" isTextarea={true} style={{ height: "100px" }} />
            </Row>
        </Form>
        );
    }; 

    const documentForm = () => (
        <Form form={form} layout="vertical">
            <div className="d-flex justify-content-between align-items-center document-header">
                <h5 className="title-addEdit-Step">Documents Business</h5>
                {/* <Button className="later-button" onClick={next}>
                Renseigner plus tard
                </Button> */}
            </div>

            <Row>
                <UploadDocument
                    label="Registre du commerce"
                    name="businessRegistryFileName"
                    value={documents.businessRegistryFileName}
                    onChange={(file) => handleDocChange("businessRegistryFileName", file)}
                    colSize={4}
                />

                <UploadDocument
                    label="Ninéa"
                    name="nineaFileName"
                    value={documents.nineaFileName}
                    onChange={(file) => handleDocChange("nineaFileName", file)}
                    colSize={4}
                />

                <UploadDocument
                    label="Statut"
                    name="statutFileName"
                    value={documents.statutFileName}
                    onChange={(file) => handleDocChange("statutFileName", file)}
                    colSize={4}
                />
            </Row>
        </Form>
    );

    const validateStep = async () => {
        const errors = await formik.validateForm();
        if (currentStep === 0) {
            const requiredFields = ["businessName", "description", "country", "sector", "type"];
            const hasErrors = requiredFields.some((field) => errors[field]);
            if (hasErrors) return toast.error("Compléter les informations du business.");
        }
        if (currentStep === 1) {
            const docsValid = validateDocuments();
            if (!docsValid) return;
        }
        if (currentStep === 2 && errors.countryPaymentMethods) {
            return toast.error("Sélectionner au moins une méthode de paiement.");
        }
        setCurrentStep(currentStep + 1);
    };

    const steps = [
        { title: "Infos basiques", content: renderBasicInfoForm },
        { title: "Documents", content: documentForm },
        { title: "Paiement", content: () => (
            <>
                <PaymentMethodSelector
                    paymentList={paymentList}
                    value={formik.values.countryPaymentMethods}
                    onChange={(val) => formik.setFieldValue("countryPaymentMethods", val)}
                    isLoadingPaym = {isLoadingPaym}
                    isErrorPaym = {isErrorPaym}
                    errorPaym = {errorPaym}
                />
                {formik.touched.countryPaymentMethods && formik.errors.countryPaymentMethods && (
                    <div className="text-danger mt-2">{formik.errors.countryPaymentMethods}</div>
                )}
            </>
        )
        },
        
        { title: "Récapitulatif", content: () => <RecapForm formData={formik.values} logo={imageUrl} documents={documents}/> },
    ];

    return (
        <div>
            <h1 className="title-addEdit-Modal mb-5">Création de mon premier business</h1>      
            <Row className="container-steps">
                <Col lg={3} className="sidebar-steps">
                    <Steps direction="vertical" current={currentStep}>
                        {steps.map((step, index) => (
                            <Step key={index} title={step.title} />
                        ))}
                    </Steps>
                </Col>
                <Col lg={8} className="content-steps">
                    {steps[currentStep].content()}
                    <div style={{ marginTop: 24 }}>
                        {error && <div className="alert alert-danger">{error.message || error.toString()}</div>}
                        {currentStep > 0 && (
                            <Button style={{ margin: "0 8px" }} onClick={prev}>Précédent</Button>
                        )}
                        {currentStep < steps.length - 1 && (
                            <Button type="primary" onClick={validateStep}>Suivant</Button>
                        )}
                        {currentStep === steps.length - 1 && (
                            <Button type="primary" onClick={formik.handleSubmit} disabled={isLoadingSubmit || isUploadingDocs}>
                                Valider mon business
                            </Button>
                        )}
                        {isLoadingSubmit && (
                            <div className="fc-loading-overlay">
                                <Lottie animationData={loadingAnim} loop={true} style={{ width: 150, height: 150 }} />
                            </div>
                        )}
                    </div>
                </Col>
            </Row>
        </div>
    );
};

export default AddFirstBusiness;
